/** "Thu 3:20 PM", in the person's own locale and time zone. */
export const formatLimitReset = (iso: string) =>
  new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit",
  });
